import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { GroupMember } from './use-load-group-members';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export type ChangeGroupMemberRoleVariables = { id: number; role: GroupMember['role'] };

export async function changeGroupMemberRoleFn(
  axiosInstance: Promise<AxiosInstance>,
  { id, role }: ChangeGroupMemberRoleVariables,
) {
  const instance = await axiosInstance;
  return instance.put(`/group/members/${id}`, { role });
}

export function useChangeGroupMemberRole() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, ChangeGroupMemberRoleVariables>({
    mutationFn: variables => changeGroupMemberRoleFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['groupMembers'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    ChangeGroupMemberRoleVariables,
    'changeGroupMemberRole'
  >('changeGroupMemberRole', mutation);
}
